import { CancelablePromise } from '../../api/core/CancelablePromise';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export interface ProductDefaultsItem {
  id: number;
  code: string;
  name: string;
  materialId: number | null;
  materialName: string | null;
  weightGrams: number | null;
  lengthMm: number | null;
  diameterSize: string | null;
  color: string | null;
  workshopCode: string | null;
  costPrice: number | null;
  salePrice: number | null;
}

export interface ProductDefaultsBatchResponse {
  data: ProductDefaultsItem[];
  missingIds: number[];
}

export class ProductsServiceHelpers {
  public static getDefaultsBatch(
    productIds: number[],
  ): CancelablePromise<ProductDefaultsBatchResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/products/defaults/batch',
      body: { productIds },
      mediaType: 'application/json',
    });
  }
}
